import { connect } from 'react-redux';
import {
    trackClickCreateAccount,
    trackClickFacebookLogin,
    trackClickGoogleLogin,
    trackClickAppleLogin,
} from '@zocdoc-frontend-common/components-sign-in-form/components/SignInFormPatientProviderMode/SignInFormPatientProviderModeActions';
import { EmailFirstSignInFormView } from './EmailFirstSignInFormView';

const mapStateToProps = (state) => {
    return {
        isProvider: state.signInForm.isProvider,
        rememberMe: state.signInForm.rememberMe,
        signedIn: state.signInForm.signedIn,
        suggestedRedirect: state.signInForm.suggestedRedirect,
    };
};

const mapDispatchToProps = {
    trackClickFacebookLogin,
    trackClickGoogleLogin,
    trackClickAppleLogin,
    trackClickSignUp: trackClickCreateAccount,
};

const EmailFirstSignInFormViewContainer = connect(
    mapStateToProps,
    mapDispatchToProps
)(EmailFirstSignInFormView);

export { EmailFirstSignInFormViewContainer as EmailFirstSignInFormView };
